/* =============================================================================
   Mahya Foundation Finder — Shade Data + Decision Matrix
   Faithful to the Competitive Research deliverable (Part 3B / 3C).
   Pure data + a few maps. No DOM here so it runs in Node for testing too.
   ============================================================================= */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.MahyaShadeData = factory();
}(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  // --- 22 Foundation SKUs -----------------------------------------------------
  // hex = approximate on-skin swatch (used to render CSS chips; replace with
  // real product hexes from Sebiha whenever available).
  var FOUNDATION = [
    { sku:'71001', name:'Ultra-Light',           depth:'fair',   undertone:'neutral',      hex:'#F2D9C4' },
    { sku:'71040', name:'Porcelain',             depth:'fair',   undertone:'cool',         hex:'#F4D7C6' },
    { sku:'71022', name:'Fair',                  depth:'fair',   undertone:'warm',         hex:'#EFCDB0' },
    { sku:'71018', name:'Fairly Light',          depth:'light',  undertone:'cool',         hex:'#EAC6AC' },
    { sku:'71016', name:'Natural',               depth:'light',  undertone:'neutral',      hex:'#E7C1A1' },
    { sku:'71037', name:'Light Beige',           depth:'light',  undertone:'neutral',      hex:'#E4BC9A' },
    { sku:'71024', name:'Medium',                depth:'light',  undertone:'neutral',      hex:'#E0B690' },
    { sku:'71500', name:'Light (Tone Corrector)',depth:'light',  undertone:'warm',         hex:'#E6C4A2' },
    { sku:'71525', name:'Sandy Beige',           depth:'light',  undertone:'warm',         hex:'#DDB088' },
    { sku:'71032', name:'Pure Beige',            depth:'medium', undertone:'neutral',      hex:'#D2A179' },
    { sku:'71033', name:'Honey Beige',           depth:'medium', undertone:'neutral_warm', hex:'#CD9B70' },
    { sku:'71039', name:'Honey',                 depth:'medium', undertone:'cool',         hex:'#D6A57F' },
    { sku:'71512', name:'Medium Beige',          depth:'medium', undertone:'warm',         hex:'#C8915F' },
    { sku:'71025', name:'Medium Tan',            depth:'tan',    undertone:'neutral_warm', hex:'#B67E4E' },
    { sku:'71527', name:'Sun Kiss',              depth:'tan',    undertone:'warm',         hex:'#AE7544' },
    { sku:'71521', name:'Sun Tan',               depth:'tan',    undertone:'neutral',      hex:'#B17B4C' },
    { sku:'71047', name:'Chocolate',             depth:'tan',    undertone:'neutral',      hex:'#9C6437' },
    { sku:'71300', name:'Toast',                 depth:'tan',    undertone:'neutral',      hex:'#945E33' },
    { sku:'71518', name:'Espresso',              depth:'deep',   undertone:'cool',         hex:'#6E4329' },
    { sku:'71027', name:'Deep',                  depth:'deep',   undertone:'warm',         hex:'#5E3722' },
    { sku:'71051', name:'African Cocoa',         depth:'deep',   undertone:'warm',         hex:'#4F2D1B' },
    { sku:'71049', name:'Dark Chocolate',        depth:'deep',   undertone:'neutral',      hex:'#5A3320' }
  ];

  // --- 21 Concealer SKUs (75022 added per CSV reconciliation in v1) -----------
  var CONCEALER = [
    { sku:'75001', name:'Ultra Light',            depth:'fair',   undertone:'neutral',      hex:'#F2D9C4' },
    { sku:'75040', name:'Porcelain',              depth:'fair',   undertone:'cool',         hex:'#F4D7C6' },
    { sku:'75022', name:'Fair',                   depth:'fair',   undertone:'warm',         hex:'#EFCDB0' },
    { sku:'75018', name:'Fairly Light',           depth:'light',  undertone:'cool',         hex:'#EAC6AC' },
    { sku:'75016', name:'Natural',                depth:'light',  undertone:'neutral',      hex:'#E7C1A1' },
    { sku:'75150', name:'Nude',                   depth:'light',  undertone:'neutral',      hex:'#E4BC9A' },
    { sku:'75024', name:'Medium',                 depth:'light',  undertone:'neutral',      hex:'#E0B690' },
    { sku:'75500', name:'Light (Tone Corrector)', depth:'light',  undertone:'warm',         hex:'#E9C7A6' },
    { sku:'75037', name:'Light Beige',            depth:'light',  undertone:'warm',         hex:'#E2B991' },
    { sku:'75525', name:'Sandy Beige',            depth:'light',  undertone:'warm',         hex:'#DDB088' },
    { sku:'75032', name:'Pure Beige',             depth:'medium', undertone:'neutral',      hex:'#D2A179' },
    { sku:'75033', name:'Honey Beige',            depth:'medium', undertone:'neutral_warm', hex:'#CD9B70' },
    { sku:'75039', name:'Honey',                  depth:'medium', undertone:'cool',         hex:'#D6A57F' },
    { sku:'75512', name:'Medium Beige',           depth:'medium', undertone:'warm',         hex:'#C8915F' },
    { sku:'75025', name:'Medium Tan',             depth:'tan',    undertone:'neutral_warm', hex:'#B67E4E' },
    { sku:'75527', name:'Sun Kiss',               depth:'tan',    undertone:'warm',         hex:'#AE7544' },
    { sku:'75521', name:'Sun Tan',                depth:'tan',    undertone:'neutral',      hex:'#B17B4C' },
    { sku:'75047', name:'Chocolate',              depth:'tan',    undertone:'neutral',      hex:'#9C6437' },
    { sku:'75300', name:'Toast',                  depth:'tan',    undertone:'neutral',      hex:'#945E33' },
    { sku:'75027', name:'Deep',                   depth:'deep',   undertone:'warm',         hex:'#5E3722' },
    { sku:'75049', name:'Dark Chocolate',         depth:'deep',   undertone:'neutral',      hex:'#5A3320' }
  ];

  // --- Foundation primary grid [depth][undertone] -> SKU ----------------------
  // Empty source cells fall back to the neutral column of the same depth
  // (deliverable Part 3B.5 decision flow, step 4). Resolved here explicitly.
  var FOUNDATION_GRID = {
    fair:   { cool:'71040', neutral:'71001', neutral_warm:'71001', warm:'71022' },
    light:  { cool:'71018', neutral:'71016', neutral_warm:'71016', warm:'71525' },
    medium: { cool:'71039', neutral:'71032', neutral_warm:'71033', warm:'71512' },
    tan:    { cool:'71521', neutral:'71521', neutral_warm:'71025', warm:'71527' },
    deep:   { cool:'71518', neutral:'71049', neutral_warm:'71049', warm:'71027' }
  };

  // Secondary (backup) foundation per cell. Values exercised by the 6 reference
  // journeys are pinned; the rest are sensible neighbours flagged for v2 review.
  var FOUNDATION_SECONDARY = {
    'fair-cool':'71018',         'fair-neutral':'71022',      'fair-neutral_warm':'71022', 'fair-warm':'71001',
    'light-cool':'71040',        'light-neutral':'71037',     'light-neutral_warm':'71525','light-warm':'71016',
    'medium-cool':'71032',       'medium-neutral':'71033',    'medium-neutral_warm':'71032','medium-warm':'71033',
    'tan-cool':'71521',          'tan-neutral':'71047',       'tan-neutral_warm':'71521',  'tan-warm':'71025',
    'deep-cool':'71049',         'deep-neutral':'71518',      'deep-neutral_warm':'71027', 'deep-warm':'71051'
  };

  // --- Concealer grid [depth][undertone] -> SKU (neutral fallback resolved) ---
  var CONCEALER_GRID = {
    fair:   { cool:'75040', neutral:'75001', neutral_warm:'75001', warm:'75022' },
    light:  { cool:'75018', neutral:'75016', neutral_warm:'75016', warm:'75037' },
    medium: { cool:'75039', neutral:'75032', neutral_warm:'75033', warm:'75512' },
    tan:    { cool:'75521', neutral:'75521', neutral_warm:'75025', warm:'75527' },
    deep:   { cool:'75049', neutral:'75049', neutral_warm:'75049', warm:'75027' }
  };

  var DEPTH_ORDER = ['fair','light','medium','tan','deep'];
  var TONE_CORRECTOR_CONCEALER = '75500';   // redness corrector
  var TONE_CORRECTOR_FOUNDATION = '71500';  // light tone-corrector base

  // index by sku for fast lookup
  function indexBySku(arr){ var m={}; arr.forEach(function(s){ m[s.sku]=s; }); return m; }

  return {
    FOUNDATION: FOUNDATION,
    CONCEALER: CONCEALER,
    FOUNDATION_GRID: FOUNDATION_GRID,
    FOUNDATION_SECONDARY: FOUNDATION_SECONDARY,
    CONCEALER_GRID: CONCEALER_GRID,
    DEPTH_ORDER: DEPTH_ORDER,
    TONE_CORRECTOR_CONCEALER: TONE_CORRECTOR_CONCEALER,
    TONE_CORRECTOR_FOUNDATION: TONE_CORRECTOR_FOUNDATION,
    foundationBySku: indexBySku(FOUNDATION),
    concealerBySku: indexBySku(CONCEALER)
  };
}));
/* =============================================================================
   Mahya Foundation Finder — Decision Engine
   Input  : answers { q1_depth, q2_jewelry, q3_vein, q4_sun, q5_skin_type,
                      q6_coverage, q7_concerns:[], q8_current_shade }
   Output : structured match (primary/secondary foundation + concealer,
            undertone, depth, confidence, uncertain flag, reasoning, add-ons).
   ============================================================================= */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) {
    module.exports = factory(require('./shade-data.js'));
  } else {
    root.MahyaEngine = factory(root.MahyaShadeData);
  }
}(typeof self !== 'undefined' ? self : this, function (D) {
  'use strict';

  // ---- config the dev can flip ---------------------------------------------
  var CONFIG = {
    // The reference deliverable (Journey 1) shows a light/cool concealer for a
    // FAIR/cool under-eye pick, which is one bucket *darker* than the match and
    // contradicts its own "1 lighter" rule. Default: clamp at the lightest
    // bucket (recommended). Set to true to reproduce the document literally.
    reproduceDocFairUndereye: false
  };

  function clampLighter(depth){
    var i = D.DEPTH_ORDER.indexOf(depth);
    return D.DEPTH_ORDER[Math.max(0, i - 1)];
  }

  // ---------------------------------------------------------------------------
  // 1. UNDERTONE SCORING
  //    cool/warm signals weighted x2 (jewelry, vein), sun reaction x1.
  // ---------------------------------------------------------------------------
  function scoreUndertone(a){
    var cool = 0, warm = 0, neutral = 0, unknown = 0;

    // Q2 jewelry
    if (a.q2_jewelry === 'silver') cool += 2;
    else if (a.q2_jewelry === 'gold') warm += 2;
    else if (a.q2_jewelry === 'both') neutral += 2;
    else unknown += 1; // 'unsure'

    // Q3 vein
    if (a.q3_vein === 'blue_purple') cool += 2;
    else if (a.q3_vein === 'green') warm += 2;
    else if (a.q3_vein === 'mixed') neutral += 2;
    else unknown += 1; // 'cant_tell'

    // Q4 sun reaction
    if (a.q4_sun === 'burns') cool += 1;
    else if (a.q4_sun === 'tans_easily' || a.q4_sun === 'golden_tan') warm += 1;
    else if (a.q4_sun === 'burns_then_tans') neutral += 1;

    return { cool: cool, warm: warm, neutral: neutral, unknown: unknown };
  }

  function resolveUndertone(s){
    var c = s.cool, w = s.warm, n = s.neutral;
    var max = Math.max(c, w, n);
    var undertone;

    if (max === 0) {
      undertone = 'neutral';                  // all signals unknown -> safe default
    } else if (w >= 2 && n >= 2 && c < 2 && w >= n) {
      undertone = 'neutral_warm';             // olive lane: warm-leaning + neutral signal
    } else if (c > w && c > n) {
      undertone = 'cool';
    } else if (w > c && w > n) {
      undertone = 'warm';
    } else if (n >= w && n >= c) {
      undertone = 'neutral';
    } else {
      undertone = 'neutral';
    }
    return undertone;
  }

  function computeConfidence(s, undertone){
    var max = Math.max(s.cool, s.warm, s.neutral);
    var conf = max / 5;                         // 0..1
    if (s.unknown >= 2) conf = Math.min(conf, 0.4);   // two+ "I don't know" answers
    if (conf < 0) conf = 0; if (conf > 1) conf = 1;
    return Math.round(conf * 100) / 100;
  }

  // ---------------------------------------------------------------------------
  // 2. CONCEALER RESOLUTION (concern-driven offset, Part 3B.5 step 5)
  // ---------------------------------------------------------------------------
  function cellOrNeutral(grid, depth, undertone){
    var row = grid[depth] || {};
    return row[undertone] || row.neutral;
  }

  function lighterConcealer(depth, undertone){
    // Prefer keeping the person's warm/nw/cool lean when stepping lighter.
    var lighter = clampLighter(depth);
    var row = D.CONCEALER_GRID[lighter] || {};
    // A neutral-warm person stepping lighter keeps a warm lean (the lighter
    // depths carry no dedicated NW chip), so use the warm column.
    if (undertone === 'neutral_warm') return row.warm || row.neutral;
    return row[undertone] || row.neutral;
  }

  function resolveConcealer(depth, undertone, concerns){
    var primary = cellOrNeutral(D.CONCEALER_GRID, depth, undertone);
    var secondary = null;
    var note = 'match'; // default

    var has = function (c){ return concerns.indexOf(c) !== -1; };

    if (has('redness')) {
      primary = D.TONE_CORRECTOR_CONCEALER;     // 75500
      note = 'tone_corrector';
    } else if (has('under_eye')) {
      note = 'lighter';
      if (depth === 'fair' && !CONFIG.reproduceDocFairUndereye) {
        primary = cellOrNeutral(D.CONCEALER_GRID, 'fair', undertone); // clamp
      } else {
        primary = lighterConcealer(depth, undertone);
      }
    } else if (has('dullness')) {
      note = 'match_plus_lighter';
      // primary matches; offer a 1-lighter brightening secondary
      secondary = lighterConcealer(depth, undertone);
    }
    // dark_spots / acne / none -> match (already set)

    return { primary: primary, secondary: secondary, note: note };
  }

  // ---------------------------------------------------------------------------
  // 3. FOUNDATION RESOLUTION
  // ---------------------------------------------------------------------------
  function resolveFoundation(depth, undertone, confidence){
    var row = D.FOUNDATION_GRID[depth] || {};
    var primary = row[undertone] || row.neutral;

    var key = depth + '-' + undertone;
    var secondary = D.FOUNDATION_SECONDARY[key] || null;

    // Uncertain + neutral default -> offer the Tone Corrector base as the gentle
    // backup (mirrors the deliverable's "Canan" fallback journey).
    if (confidence <= 0.60 && undertone === 'neutral' && depth === 'light') {
      secondary = D.TONE_CORRECTOR_FOUNDATION; // 71500
    }
    if (secondary === primary) secondary = null;
    return { primary: primary, secondary: secondary };
  }

  // ---------------------------------------------------------------------------
  // 4. ADD-ONS / EDUCATION based on skin type + coverage
  // ---------------------------------------------------------------------------
  function buildAddons(skin, coverage){
    var addons = [];
    if (skin === 'dry') addons.push('hydrating_primer');
    if (skin === 'oily' || skin === 'combination') addons.push('setting_powder');
    if (coverage === 'full') addons.push('setting_powder');
    // de-dupe
    return addons.filter(function (v, i){ return addons.indexOf(v) === i; });
  }

  // ---------------------------------------------------------------------------
  // MAIN
  // ---------------------------------------------------------------------------
  function evaluate(answers){
    var a = Object.assign({ q7_concerns: [] }, answers);
    if (!Array.isArray(a.q7_concerns)) a.q7_concerns = a.q7_concerns ? [a.q7_concerns] : [];

    var depth = a.q1_depth;
    var s = scoreUndertone(a);
    var undertone = resolveUndertone(s);
    var confidence = computeConfidence(s, undertone);
    var uncertain = confidence <= 0.60;

    var f = resolveFoundation(depth, undertone, confidence);
    var c = resolveConcealer(depth, undertone, a.q7_concerns);

    var fPrim = D.foundationBySku[f.primary] || null;
    var fSec  = f.secondary ? (D.foundationBySku[f.secondary] || null) : null;
    var cPrim = D.concealerBySku[c.primary] || null;
    var cSec  = c.secondary ? (D.concealerBySku[c.secondary] || null) : null;

    return {
      depth_detected: depth,
      undertone_detected: undertone,
      confidence: confidence,
      uncertain: uncertain,
      scores: s,
      foundation_primary_sku: f.primary,
      foundation_primary: fPrim,
      foundation_secondary_sku: f.secondary,
      foundation_secondary: fSec,
      concealer_primary_sku: c.primary,
      concealer_primary: cPrim,
      concealer_secondary_sku: c.secondary,
      concealer_secondary: cSec,
      concealer_note: c.note,
      skin_type: a.q5_skin_type,
      coverage: a.q6_coverage,
      concerns: a.q7_concerns,
      current_shade: a.q8_current_shade || null,
      addons: buildAddons(a.q5_skin_type, a.q6_coverage)
    };
  }

  return { evaluate: evaluate, scoreUndertone: scoreUndertone, resolveUndertone: resolveUndertone, CONFIG: CONFIG };
}));
/* =============================================================================
   Mahya Foundation Finder — UI Controller
   Renders the 8-question flow, computes a match via MahyaEngine, and produces
   a downloadable PNG of the result. English-first; Turkish strings included so
   the same build flips locale later.
   Depends on: window.MahyaShadeData, window.MahyaEngine.
   Optional   : window.MahyaFinderConfig { locale, currency, price, productUrls,
                variantIds, shopUrl, html2canvas:true }
   ============================================================================= */
(function () {
  'use strict';

  var D = window.MahyaShadeData;
  var Engine = window.MahyaEngine;
  var CFG = window.MahyaFinderConfig || {};

  var LOCALE   = (CFG.locale || 'en').slice(0, 2);
  var CURRENCY = CFG.currency || '$';
  var PRICE    = CFG.price != null ? CFG.price : 24.99;
  var CONC_PRICE = CFG.concealerPrice != null ? CFG.concealerPrice : 24.99;
  var PRODUCT_URLS = CFG.productUrls || {};   // { foundation:'/products/..', concealer:'/products/..' }
  var VARIANT_IDS  = CFG.variantIds  || {};   // { '71033':'123456789', ... }
  var LOGO_URL = CFG.logoUrl || '';            // brand logo (optional)
  var DISCOUNT_PCT = CFG.discountPercent != null ? CFG.discountPercent : 10;
  var DISCOUNT_CODE = CFG.discountCode || '';  // optional — shown as "Use code X" if set

  function t(en, tr){ return LOCALE === 'tr' ? tr : en; }
  function money(n){ return CURRENCY + Number(n).toFixed(2); }
  function ga(name, params){ if (typeof window.gtag === 'function') window.gtag('event', name, params || {}); }

  // ---- question set ---------------------------------------------------------
  var QUESTIONS = [
    { id:'q1_depth', type:'single', visual:true, required:true,
      kicker:t('Step 1 · Skin depth','Adım 1 · Cilt derinliği'),
      title:t('Which is closest to your natural skin?','Doğal cildinize en yakın olan hangisi?'),
      help:t('No makeup, in daylight. Check your jawline — not the back of your hand.','Makyajsız, gün ışığında. El sırtınıza değil, çene çizginize bakın.'),
      options:[
        { value:'fair',   label:t('Fair','Çok Açık'),  hex:'#F2D9C4' },
        { value:'light',  label:t('Light','Açık'),     hex:'#E7C1A1' },
        { value:'medium', label:t('Medium','Orta'),    hex:'#CD9B70' },
        { value:'tan',    label:t('Tan','Bronz'),      hex:'#B17B4C' },
        { value:'deep',   label:t('Deep','Koyu'),      hex:'#5E3722' }
      ] },
    { id:'q2_jewelry', type:'single', required:true,
      kicker:t('Step 2 · Undertone','Adım 2 · Alt ton'),
      title:t('Which metal flatters you most?','Hangi metal teninizde daha güzel duruyor?'),
      help:t('Gold tends to flatter warm undertones, silver flatters cool.','Altın sıcak, gümüş soğuk alt tonları öne çıkarır.'),
      options:[
        { value:'gold',   label:t('Gold','Altın') },
        { value:'silver', label:t('Silver','Gümüş') },
        { value:'both',   label:t('Both look good','İkisi de güzel') },
        { value:'unsure', label:t('Not sure','Emin değilim') }
      ] },
    { id:'q3_vein', type:'single', visual:true, required:true,
      kicker:t('Step 3 · Undertone','Adım 3 · Alt ton'),
      title:t('What colour are your wrist veins?','Bilek damarlarınız hangi renk?'),
      help:t('Look at the inside of your wrist near a window.','Bileğinizin iç kısmına pencere ışığında bakın.'),
      options:[
        { value:'blue_purple', label:t('Blue / purple','Mavi / mor'), vein:'cool' },
        { value:'green',       label:t('Green','Yeşil'),               vein:'warm' },
        { value:'mixed',       label:t('Mixed','Karışık'),             vein:'neutral' },
        { value:'cant_tell',   label:t("Can't tell",'Göremiyorum'),    vein:'unknown' }
      ] },
    { id:'q4_sun', type:'single', required:true,
      kicker:t('Step 4 · Undertone','Adım 4 · Alt ton'),
      title:t('How does your skin react to the sun?','Cildiniz güneşe nasıl tepki verir?'),
      options:[
        { value:'burns',           label:t('Burns quickly','Hemen yanar') },
        { value:'burns_then_tans', label:t('Burns, then tans','Önce yanar, sonra bronzlaşır') },
        { value:'tans_easily',     label:t('Tans easily','Kolay bronzlaşır') },
        { value:'golden_tan',      label:t('Golden tan','Altın tonlu bronzlaşır') }
      ] },
    { id:'q5_skin_type', type:'single', required:true,
      kicker:t('Step 5 · Formula','Adım 5 · Formül'),
      title:t('What is your skin type?','Cilt tipiniz nedir?'),
      options:[
        { value:'oily',        label:t('Oily','Yağlı') },
        { value:'dry',         label:t('Dry','Kuru') },
        { value:'combination', label:t('Combination','Karma') },
        { value:'normal',      label:t('Normal','Normal') },
        { value:'sensitive',   label:t('Sensitive','Hassas') }
      ] },
    { id:'q6_coverage', type:'single', required:true,
      kicker:t('Step 6 · Coverage','Adım 6 · Kapatıcılık'),
      title:t('How much coverage do you like?','Nasıl bir kapatıcılık istersiniz?'),
      options:[
        { value:'light',  label:t('Light & natural','Hafif, doğal') },
        { value:'medium', label:t('Medium','Orta') },
        { value:'full',   label:t('Full','Tam kapatıcılık') }
      ] },
    { id:'q7_concerns', type:'multi', required:true, max:2,
      kicker:t('Step 7 · Concealer','Adım 7 · Kapatıcı'),
      title:t('What do you most want to conceal?','En çok neyi kapatmak istersiniz?'),
      help:t('Choose up to two. This sets your concealer pairing.','En fazla iki seçin. Bu, kapatıcı eşleşmenizi belirler.'),
      options:[
        { value:'redness',    label:t('Redness','Kızarıklık') },
        { value:'under_eye',  label:t('Under-eye circles','Göz altı morlukları') },
        { value:'dark_spots', label:t('Dark spots','Koyu lekeler') },
        { value:'acne',       label:t('Acne scars','Sivilce izleri') },
        { value:'dullness',   label:t('Dullness','Donukluk') },
        { value:'none',       label:t('None','Hiçbiri') }
      ] },
    { id:'q8_current_shade', type:'text', required:false,
      kicker:t('Step 8 · Optional','Adım 8 · Opsiyonel'),
      title:t('What foundation do you wear now?','Şu anda hangi fondöteni kullanıyorsunuz?'),
      help:t('Optional — gives us an extra anchor. Feel free to skip.','Opsiyonel — ekstra bir referans verir. Atlayabilirsiniz.'),
      placeholder:t('e.g. MAC NC30, Fenty 240','Örn: MAC NC30, Fenty 240') }
  ];

  // ---- state ----------------------------------------------------------------
  var root, answers, step;

  function init(){
    root = document.getElementById('mahya-shade-finder');
    if (!root || !D || !Engine) return;
    answers = {}; step = -1; // -1 = intro
    renderIntro();
  }

  // ---- screens --------------------------------------------------------------
  function renderIntro(){
    root.innerHTML =
      '<div class="msf-card"><div class="msf-intro">' +
        (LOGO_URL ? '<img class="msf-intro__logo" src="' + LOGO_URL + '" alt="Mahya" />' : '') +
        '<p class="msf-intro__eyebrow">' + t('Base Match','Ton Eşleştirme') + '</p>' +
        '<h2 class="msf-intro__title">' + t('Find your foundation','Tonunuzu bulun') + '</h2>' +
        '<p class="msf-intro__sub">' + t(
          'Eight quick questions and we\'ll match you to your Mahya mineral shade — base and concealer.',
          'Sekiz kısa soru, size özel Mahya mineral tonunu bulalım — fondöten ve kapatıcı.') + '</p>' +
        '<div class="msf-intro__meta"><span>' + t('≈ 90 seconds','≈ 90 saniye') + '</span>' +
          '<span>' + t('22 shades','22 ton') + '</span><span>' + t('No email needed','E-posta gerekmez') + '</span></div>' +
        '<button class="msf-btn msf-btn--primary" id="msf-start">' + t('Start','Başla') + ' →</button>' +
      '</div></div>';
    root.querySelector('#msf-start').addEventListener('click', function(){ ga('shade_finder_start'); step = 0; renderStep(); });
  }

  function renderStep(){
    var q = QUESTIONS[step];
    var total = QUESTIONS.length;
    var pct = Math.round((step / total) * 100);

    var html = '<div class="msf-card">' +
      '<div class="msf-progress"><div class="msf-progress__meta">' +
        '<span>' + t('Question','Soru') + ' ' + (step + 1) + ' / ' + total + '</span>' +
        '<span>' + pct + '%</span></div>' +
        '<div class="msf-progress__bar"><div class="msf-progress__fill" style="width:' + pct + '%"></div></div></div>' +
      '<div class="msf-q">' +
        '<p class="msf-q__kicker">' + q.kicker + '</p>' +
        '<h3 class="msf-q__title">' + q.title + '</h3>' +
        (q.help ? '<p class="msf-q__help">' + q.help + '</p>' : '');

    if (q.type === 'text') {
      html += '<input type="text" id="msf-text" class="msf-opt" style="width:100%;border-radius:12px;justify-content:flex-start" ' +
              'placeholder="' + (q.placeholder || '') + '" value="' + (answers[q.id] || '') + '">';
    } else {
      var cls = 'msf-opts' + (q.visual ? ' msf-opts--visual' : '');
      html += '<div class="' + cls + '" role="group">';
      q.options.forEach(function(o){
        var sel = q.type === 'multi'
          ? (answers[q.id] || []).indexOf(o.value) !== -1
          : answers[q.id] === o.value;
        var inner;
        if (q.id === 'q1_depth') {
          inner = '<span class="msf-swatch" style="background:' + o.hex + '"></span>' +
                  '<span class="msf-opt__label">' + o.label + '</span>';
          html += '<button class="msf-opt msf-opt--chip" data-v="' + o.value + '" aria-pressed="' + sel + '">' + inner + '</button>';
        } else if (q.id === 'q3_vein') {
          inner = veinIllus(o.vein) + '<span class="msf-opt__label">' + o.label + '</span>';
          html += '<button class="msf-opt msf-opt--chip" data-v="' + o.value + '" aria-pressed="' + sel + '">' + inner + '</button>';
        } else {
          html += '<button class="msf-opt" data-v="' + o.value + '" aria-pressed="' + sel + '">' + o.label + '</button>';
        }
      });
      html += '</div>';
      if (q.type === 'multi') html += '<p class="msf-multi-hint">' + t('Select up to 2','En fazla 2 seçin') + '</p>';
    }

    // nav
    html += '<div class="msf-nav">' +
      '<button class="msf-btn msf-btn--ghost" id="msf-back">' + (step === 0 ? t('Back','Geri') : '← ' + t('Back','Geri')) + '</button>';
    if (q.type === 'multi' || q.type === 'text') {
      var label = (q.type === 'text' && !q.required) ? t('Skip','Atla') : t('Continue','Devam');
      html += '<button class="msf-btn msf-btn--primary" id="msf-next">' + label + ' →</button>';
    } else {
      html += '<span style="font-size:12px;color:var(--msf-muted)">' + t('Tap to continue','Seçince ilerler') + '</span>';
    }
    html += '</div></div>';

    root.innerHTML = html;
    requestAnimationFrame(function(){ root.querySelector('.msf-progress__fill').style.width = pct + '%'; });
    bindStep(q);
  }

  function bindStep(q){
    var back = root.querySelector('#msf-back');
    if (back) back.addEventListener('click', function(){
      if (step === 0) { step = -1; renderIntro(); } else { step--; renderStep(); }
    });

    if (q.type === 'text') {
      var input = root.querySelector('#msf-text');
      root.querySelector('#msf-next').addEventListener('click', function(){
        answers[q.id] = input.value.trim();
        ga('shade_finder_answer', { question: q.id });
        finish();
      });
      return;
    }

    var btns = root.querySelectorAll('.msf-opt[data-v]');
    btns.forEach(function(b){
      b.addEventListener('click', function(){
        var v = b.getAttribute('data-v');
        if (q.type === 'multi') {
          var cur = answers[q.id] || [];
          if (v === 'none') { cur = ['none']; }
          else {
            cur = cur.filter(function(x){ return x !== 'none'; });
            var i = cur.indexOf(v);
            if (i !== -1) cur.splice(i, 1);
            else if (cur.length < (q.max || 2)) cur.push(v);
          }
          answers[q.id] = cur;
          btns.forEach(function(x){
            var on = cur.indexOf(x.getAttribute('data-v')) !== -1;
            x.setAttribute('aria-pressed', on);
          });
        } else {
          answers[q.id] = v;
          ga('shade_finder_answer', { question: q.id, value: v });
          advance();
        }
      });
    });

    var next = root.querySelector('#msf-next');
    if (next && q.type === 'multi') next.addEventListener('click', function(){
      if (!(answers[q.id] && answers[q.id].length)) return;
      ga('shade_finder_answer', { question: q.id });
      advance();
    });
  }

  function advance(){ if (step < QUESTIONS.length - 1) { step++; renderStep(); } else { finish(); } }

  // ---- result ---------------------------------------------------------------
  function finish(){
    var r = Engine.evaluate(answers);
    ga('shade_finder_complete', {
      undertone: r.undertone_detected, depth: r.depth_detected,
      foundation: r.foundation_primary_sku, concealer: r.concealer_primary_sku,
      confidence: r.confidence, uncertain: r.uncertain
    });
    renderResult(r);
  }

  function confBand(c){
    if (c >= 0.85) return { label:t('Strong match','Güçlü eşleşme'), color:'#6E8B6A' };
    if (c >  0.60) return { label:t('Good match','İyi eşleşme'),   color:'#C08B6E' };
    return { label:t("Let's narrow it down","Biraz daraltalım"),    color:'#B98A6B' };
  }

  function matchRow(item, kind, price, alt, productKind){
    if (!item) return '';
    var href = productKind ? productHref(item.sku, productKind) : null;
    var tag = href ? 'a' : 'div';
    var hrefAttr = href ? ' href="' + href + '"' : '';
    return '<' + tag + ' class="msf-match__row' + (alt ? ' msf-match__row--alt' : '') + (href ? ' msf-match__row--link' : '') + '"' + hrefAttr + '>' +
      '<span class="msf-match__swatch" style="background:' + item.hex + '"></span>' +
      '<div class="msf-match__body">' +
        '<div class="msf-match__kind">' + kind + '</div>' +
        '<div class="msf-match__name">' + item.name + '</div>' +
        '<div class="msf-match__sku">SKU ' + item.sku + '</div>' +
      '</div>' +
      (price != null ? '<div class="msf-match__price">' + money(price) + '</div>' : '') +
      (href ? '<span class="msf-match__arrow" aria-hidden="true">→</span>' : '') +
    '</' + tag + '>';
  }

  function reasoning(r){
    var u = { cool:t('cool','soğuk'), warm:t('warm','sıcak'),
              neutral:t('neutral','nötr'), neutral_warm:t('neutral-warm (olive)','nötr-sıcak (zeytin)') }[r.undertone_detected];
    var d = { fair:'Fair', light:'Light', medium:'Medium', tan:'Tan', deep:'Deep' }[r.depth_detected];
    return t(
      'A ' + u + ' undertone at ' + d.toLowerCase() + ' depth. ' + r.foundation_primary.name + ' is your closest base.',
      'Cilt derinliği ' + d.toLowerCase() + ', alt ton ' + u + '. Size en yakın baz: ' + r.foundation_primary.name + '.');
  }

  function notes(r){
    var out = [];
    if (r.skin_type === 'dry') out.push('<p>' + t(
      '<strong>Dry skin tip:</strong> our mineral base is matte — prep with a hydrating primer first.',
      '<strong>Kuru cilt ipucu:</strong> mineral bazımız mattır — önce nemlendirici primer kullanın.') + '</p>');
    if (r.skin_type === 'sensitive') out.push('<p>' + t(
      '<strong>Sensitive skin:</strong> 100% mineral, fragrance-free, breathable.',
      '<strong>Hassas cilt:</strong> %100 mineral, parfümsüz, nefes alabilen.') + '</p>');
    if (r.concealer_note === 'tone_corrector') out.push('<p>' + t(
      'Your Tone Corrector concealer neutralises redness before foundation.',
      'Tone Corrector kapatıcınız, fondötenden önce kızarıklığı dengeler.') + '</p>');
    return out.length ? '<div class="msf-notes">' + out.join('') + '</div>' : '';
  }

  // First-order discount — universal closing nudge (visible to everyone).
  function promo(){
    var headEn = '<strong>' + DISCOUNT_PCT + '% off your first order</strong> — applied at checkout.';
    var headTr = '<strong>İlk alışverişinize özel %' + DISCOUNT_PCT + ' indirim</strong> — checkout\'ta uygulanır.';
    if (DISCOUNT_CODE) {
      headEn = '<strong>' + DISCOUNT_PCT + '% off your first order.</strong> Use code <code>' + DISCOUNT_CODE + '</code> at checkout.';
      headTr = '<strong>İlk alışverişinize özel %' + DISCOUNT_PCT + ' indirim.</strong> Checkout\'ta <code>' + DISCOUNT_CODE + '</code> kodunu kullanın.';
    }
    return '<div class="msf-promo"><span class="msf-promo__icon" aria-hidden="true">✦</span>' +
      '<p>' + t(headEn, headTr) + '</p></div>';
  }

  function productHref(sku, kind){
    // Always go to the PRODUCT PAGE (not /cart/add) — relative URL so it works
    // on any storefront domain. Pre-select the variant via ?variant= if known,
    // so when the customer lands on the product page their shade is already
    // chosen and the swatch is highlighted.
    var base = PRODUCT_URLS[kind] || ('/products/' + (kind === 'concealer' ? 'powder-concealer' : 'powder-foundation'));
    if (VARIANT_IDS[sku]) return base + (base.indexOf('?') === -1 ? '?' : '&') + 'variant=' + VARIANT_IDS[sku];
    return base;
  }

  function renderResult(r){
    var band = confBand(r.confidence);
    var pct = Math.round(r.confidence * 100);

    var html = '<div class="msf-result">' +
      '<div class="msf-shot" id="msf-shot">' +
        '<div class="msf-result__brand">' +
          (LOGO_URL
            ? '<img class="msf-result__logo" src="' + LOGO_URL + '" alt="Mahya" />'
            : '<span class="msf-result__wordmark">Mahya</span>') +
          '<div class="msf-result__tags">' +
            '<span class="msf-tag">' + r.depth_detected + '</span>' +
            '<span class="msf-tag">' + r.undertone_detected.replace('_',' ') + '</span>' +
          '</div>' +
        '</div>' +
        '<h3 class="msf-result__headline">' + t('Your match','Eşleşmeniz') + '</h3>' +
        '<p class="msf-result__lead">' + reasoning(r) + '</p>' +
        '<div class="msf-match">' +
          matchRow(r.foundation_primary, t('Foundation','Fondöten'), PRICE, false, 'foundation') +
          (r.concealer_primary ? matchRow(r.concealer_primary, t('Concealer','Kapatıcı'), CONC_PRICE, false, 'concealer') : '') +
        '</div>';

    if (r.foundation_secondary || r.concealer_secondary) {
      html += '<p class="msf-alt-label">' + t('Also worth trying','Bunları da deneyebilirsiniz') + '</p><div class="msf-match">';
      html += matchRow(r.foundation_secondary, t('Foundation backup','Yedek fondöten'), null, true, 'foundation');
      html += matchRow(r.concealer_secondary, t('Concealer backup','Yedek kapatıcı'), null, true, 'concealer');
      html += '</div>';
    }

    html += '<div class="msf-conf"><div class="msf-conf__top">' +
      '<span class="msf-conf__label">' + t('Match confidence','Eşleşme güveni') + '</span>' +
      '<span class="msf-conf__band" style="color:' + band.color + '">' + band.label + ' · ' + pct + '%</span></div>' +
      '<div class="msf-conf__track"><div class="msf-conf__fill" style="width:' + pct + '%;background:' + band.color + '"></div></div></div>';

    html += notes(r);
    html += promo();
    html += '</div>'; // /msf-shot

    // actions (outside the captured shot)
    html += '<div class="msf-actions">' +
      '<a class="msf-btn msf-btn--primary" href="' + productHref(r.foundation_primary_sku,'foundation') + '">' + t('Shop foundation','Fondöteni al') + '</a>' +
      (r.concealer_primary ? '<a class="msf-btn msf-btn--ghost" href="' + productHref(r.concealer_primary_sku,'concealer') + '">' + t('Shop concealer','Kapatıcıyı al') + '</a>' : '') +
      '<button class="msf-btn msf-btn--ghost msf-actions__full" id="msf-download">⬇ ' + t('Download my match','Eşleşmemi indir') + '</button>' +
    '</div>' +
    '<div class="msf-restart"><button class="msf-btn msf-btn--link" id="msf-restart">' + t('Retake the quiz','Testi tekrar yap') + '</button></div>' +
    '</div>';

    root.innerHTML = html;
    root.querySelector('#msf-restart').addEventListener('click', function(){ answers = {}; step = -1; ga('shade_finder_restart'); renderIntro(); });
    root.querySelector('#msf-download').addEventListener('click', function(){ downloadShot(r); });
  }

  // ---- screenshot download (html2canvas) ------------------------------------
  function downloadShot(r){
    var node = root.querySelector('#msf-shot');
    if (!node) return;
    ga('shade_finder_download', { foundation: r.foundation_primary_sku });

    function run(){
      window.html2canvas(node, { backgroundColor: '#FBF6F1', scale: 2, useCORS: true, logging: false })
        .then(function(canvas){
          var link = document.createElement('a');
          link.download = 'mahya-match-' + r.foundation_primary_sku + '.png';
          link.href = canvas.toDataURL('image/png');
          link.click();
        })
        .catch(function(){ alert(t('Could not generate the image. Please screenshot manually.','Görsel oluşturulamadı. Lütfen ekran görüntüsü alın.')); });
    }

    if (window.html2canvas) { run(); return; }
    // lazy-load the library on first use
    var s = document.createElement('script');
    s.src = 'https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js';
    s.onload = run;
    s.onerror = function(){ alert(t('Could not load the image tool. Please screenshot manually.','Görsel aracı yüklenemedi. Lütfen ekran görüntüsü alın.')); };
    document.head.appendChild(s);
  }

  // ---- inline SVG vein illustrations ----------------------------------------
  function veinIllus(kind){
    var stroke = { cool:'#7E8FB5', warm:'#7FA06B', neutral:'#9A8FA8', unknown:'#C9BCB0' }[kind] || '#C9BCB0';
    var q = kind === 'unknown' ? '<text x="22" y="27" font-size="20" text-anchor="middle" fill="' + stroke + '">?</text>' :
      '<path d="M14 6 C16 16 12 24 16 38" stroke="' + stroke + '" stroke-width="2.4" fill="none" stroke-linecap="round"/>' +
      '<path d="M26 6 C24 18 30 26 26 38" stroke="' + stroke + '" stroke-width="2.4" fill="none" stroke-linecap="round"/>' +
      (kind === 'neutral' ? '<path d="M20 8 C21 20 19 28 21 36" stroke="#7FA06B" stroke-width="2" fill="none" stroke-linecap="round" opacity=".8"/>' : '');
    return '<svg class="msf-illus" viewBox="0 0 44 44" aria-hidden="true">' +
      '<rect x="2" y="2" width="40" height="40" rx="12" fill="rgba(255,255,255,.6)"/>' + q + '</svg>';
  }

  // ---- expose for self-test -------------------------------------------------
  window.MahyaFinder = { init: init };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
